import { priorCarriers } from "@covertree/consts";

import { Coverage } from "@graphql/api";

import { CoverageFormDataWithTimestamps } from "@redux/coverages/types";

/**
 * Maps already existing External Coverage to the CoverageFormDataWithTimestamps
 * format used in the form.
 * This is used to pre-populate the form when editing an existing coverage, or from an uploaded policy document.
 * @param coverage
 */
export const mapExternalCoverageToExternalCoverageFormData = (
  coverage: Coverage
): CoverageFormDataWithTimestamps => {
  const insuranceCarrierOption = priorCarriers.find(
    ({ value }) => value === coverage.insuranceCarrierName
  );

  const manufacturer = coverage.coverageDetails?.manufacturer;
  const modelYear = coverage.coverageDetails?.modelYear;

  return {
    insuranceCarrierName: insuranceCarrierOption ?? null,
    isOtherInsuranceCarrier: !insuranceCarrierOption,
    ...(!insuranceCarrierOption
      ? { otherInsuranceCarrierName: coverage.insuranceCarrierName }
      : {}),
    policyId: coverage.policyId,
    description: coverage.policyDescription,
    policyEffectiveDate: coverage.policyEffectiveDate
      ? new Date(`${coverage.policyEffectiveDate} 00:00:00`)
      : undefined,
    policyEndDate: coverage.policyEndDate
      ? new Date(`${coverage.policyEndDate} 00:00:00`)
      : undefined,
    annualCost: coverage.annualCost,
    agencyName: coverage.agencyName,
    agencyAddress: coverage.agencyAddress,
    agencyPhoneNumber: coverage.agencyPhoneNumber,
    agencyEmail: coverage.agencyEmail,
    isInternalSale: coverage.isInternalSale,
    withHomeDetails: !!coverage.coverageDetails,
    occupancyType: coverage.coverageDetails?.occupancy,
    manufacturer: !!manufacturer
      ? {
          label: manufacturer,
          value: manufacturer,
        }
      : null,
    homeType: coverage.coverageDetails?.homeType,
    modelYear: !!modelYear
      ? { label: modelYear.toString(), value: modelYear.toString() }
      : null,
    personalLiabilityLimit:
      coverage.coverageDetails?.personalLiabilityLimit || null,
    homeCoverageLimit: coverage.coverageDetails?.homeCoverageLimit || null,
    otherStructuresLimit:
      coverage.coverageDetails?.otherStructuresLimit || null,
    personalPropertyLimit:
      coverage.coverageDetails?.personalPropertyLimit || null,
    standardDeductibleLimit:
      coverage.coverageDetails?.standardDeductibleLimit || null,
    animalLiabilityLimit:
      coverage.coverageDetails?.animalLiabilityLimit || null,
    medicalPaymentsLimit:
      coverage.coverageDetails?.medicalPaymentsLimit || null,
  };
};
